export const DATA = [
  {
    title: 'Casas',
    items: [
      {
        id: 1,
        code: 'CA001',
        name: 'Hermosa Casa Tipo Chalet, Luminosa, En El Exclusivo Barrio Residencial Arrayanes De El Bolsón',
        address: 'A 7 cuadras del centro de Bolsón',
        imageUrl: 'http://347inmobiliaria.com/img/1.jpg',
        description: 'Comedor, Living, Jardín, Cocina, Lavadero, TV por cable, Línea telefónica, Gas natural, Placards. Venir a vivir a un lugar tranquilo, rodeado de naturaleza y buena gente de barrio. Casita de Construcción de calidad con material de arquitectura espontanea. Muy Buena ubicación residencial barrial, con loza radiante en todos los ambientes haciendo que el dia a dia sea más calido un bello jardin de suelo plano. Plaza de juegos en el Barrio. Todos los servicios.',
        price: 'USD 120.000',
        size: '475 m²',
        build: '87.5 m²',
        cover: '61 m²',
        rooms: '3',
        bedrooms: '2',
        bathroom: '1',
        storage: '',
        garage: '1',
        floors: '1',
        orientation: 'norte',
        antiquity: '20 años',
      },
      {
        id: 5,
        code: 'CA003',
        name: 'Casa Nueva!!!! Muy Luminosa, Varios Ambientes. En Alto Di Puelo, Destino Turístico Por Excelencia. Lago Puelo, Chubut',
        address: 'a 1 km del centro de Lago Puelo',
        imageUrl: 'http://347inmobiliaria.com/img/5.jpg',
        description: 'Hermosa casa con amplias ventanas, gran living comedor con estufa a leña en el centro, muy calentita en invierno, toda la casa cuenta con doble vidrio. Gran jardín al rededor de la casa, con árbol frutal de ciruelas. con preciosa vista hacia la montaña copada de árboles autóctonos, fácil acceso al barrio por camino de azfalto alternativo de la ruta 16',
        price: 'USD 180.000',
        size: '908 m²',
        build: '135 m²',
        cover: '95 m²',
        rooms: '4',
        bedrooms: '3',
        bathroom: '2',
        garage: '1',
        storage: '',
        floors: '2',
        orientation: 'Oeste',
        antiquity: '2 años',
      },
      {
        id: 6,
        code: 'CA002',
        name: 'Mudarte A La Patagonia Es Posible!! Una Casa Para Vivir Y Otra para La Renta en la exclusiva zona Villa Del Lago, Lago Puelo, Chubut',
        address: 'Ubicación callejón el tero, a dos cuadras de la ruta 16, villa del lago, Lago Puelo, chubut',
        imageUrl: 'http://347inmobiliaria.com/img/6.png',
        description: '*Ambientes: Comedor, Estudio, Living, Patio, Jardín, Cocina, Dependencia de servicio, Playroom, Lavadero. *Comodidades y equipamiento: Comedor, Estudio, Living, Patio, Jardín, Cocina, Dependencia de servicio, Playroom. *Características adicionales: Acceso a internet, Parrilla. -Terreno 714 m2 En una zona exclusiva, camino al lago de Lago Puelo. Hoy en día considerado boom turístico de la Patagonia. Son dos casas de construcción rústicas construidas por sus mismos dueños, con la elección y dedicación que eso implica. -Venden por viaje. -Ubicación callejón el tero, villa del lago, Lago Puelo, chubut. Calle de ripio, a dos cuadras de la ruta 16 (azfalto). -2 casas: Una para vivir y otra para renta; o compartir en familia. +Primer casa: 58,68 m². superficie cubierta + 12 m² semi cubierta. 10 años de antigüedad. Da hacia la calle con jardín en la entrada. consta de dos plantas; living, cocina, comedor, con habitación en planta baja y baño completo. Posibilidad de ampliación. Planta alta de dos habitaciones y sala de estar o play room. Muy luminosa. (hoy alquilada, con muy buenos inquilinos). Ancho de puertas amplias y agarradera en la ducha, como para considerar situación de silla de ruedas y/o gente mayor o con dificultad de traslado. +Segunda casa: de una sola planta, de 35,5 m² superficie cubierta + 12 m² semi cubierta, 20 años de antigüedad; 2 habitaciones, Cocina/comedor, baño, lavadero, pequeño taller y patio con alero. cuenta con gran jardín en la parte trasera de la casa. Todos los servicios, teléfono fijo, electricidad, gas natural. Amplio jardín con enorme cerezo y flores. Parrilla. Pozo de agua para riego, dos tanques de reserva de agua. Ambas casas con cocheras con entrada independiente y techadas. *Aceptan camioneta en parte de pago.',
        price: 'USD 150.000',
        size: '714 m²',
        build: '70.68 m²',
        cover: '58.68 m²',
        rooms: '5',
        bedrooms: '3',
        bathroom: '1',
        garage: '2',
        storage: '2',
        floors: '2',
        orientation: 'Oeste',
        antiquity: '10 años',
      },
      {
        id: 7,
        code: 'CA004',
        name: 'Casa 2 Dormitorios, Con 2,300 M² De Terrreno, En Cerro Amigo Cerca Al Mirador De El Bolsón, Amplio Jardín',
        address: 'a tan solo 10 minutos del centro de El Bolsón',
        imageUrl: 'http://347inmobiliaria.com/img/7.png',
        description: '*Ambientes, Comodidades y equipamiento: Comedor, Living, Cocina, Lavadero, Jardín. *Características adicionales: *Condiciones especiales. Casa de amplios ambientes con precioso jardín, Tanque de agua. ´Arboles frutales, tierra cultivable en terrazas. Una vida de ensueño, vivir en alto, en una zona tranquila, con la naturaleza, rodeada de árboles autóctonos y montañas, a pocos metros del Mirador de El Bolsón, una caminata preciosa de árboles que dan gran frescor en verano y al final te encuentras con una vista panorámica del valle y sus alrededores. La casa se encuentra a tan solo 10 minutos del centro de El Bolsón, zona turística por excelencia.',
        price: 'USD 99.000',
        size: '2300 m²',
        build: '65.59 m²',
        cover: '65.59 m²',
        rooms: '3',
        bedrooms: '2',
        bathroom: '1',
        garage: '1',
        storage: '',
        floors: '2',
        orientation: 'Oeste',
        antiquity: '10 años',
      },
      {
        id: 8,
        code: 'CA005',
        name: 'Casa Nueva, Una Sola Planta, En Barrio Residencial De Lago Puelo, Cerca Al Rio Azul',
        address: 'Lago Puelo, Cerca Al Rio Azul',
        imageUrl: 'http://347inmobiliaria.com/img/8.png',
        description: '*Casa de amplios ambientes de área social. Agradable distribución con doble entrada, principal y de servicio. Muy Luminosa, en una sola planta de 3 dormitorios (uno en suite), 2 baños completos con bañera, cuenta con altillo para guardar cosas. Gran Jardín en Terreno de 600 m², algunos frutales y cuenta con hermosa vista hacia el Cerro Motoco y sus cascadas, hermoso atractivo turístico de Lago Puelo. Tiene Pozo de agua para riego. -Todos los servicios: agua corriente, luz, gas natural, internet. Es un barrio tranquilo, silencioso, calle de ripio. -Se acepta permuta como parte de pago',
        price: 'USD 120.000',
        size: '100 m²',
        build: '100 m²',
        cover: '100 m²',
        rooms: '4',
        bedrooms: '3',
        bathroom: '2',
        garage: '',
        storage: '1',
        floors: '1',
        orientation: 'Este',
        antiquity: '3 años',
      },
    ]
  },
  {
    title: 'Departamentos',
    items: [
      {
        id: 2,
        code: 'DE001',
        name: 'Excelente Ubicacion Departamento Martinez, zona Norte, Buenos Aires',
        address: 'Martinez, zona Norte, Buenos Aires',
        imageUrl: 'http://347inmobiliaria.com/img/2.jpg',
        description: '',
        price: 'USD 120.000',
        expenses: '$7000',
        size: '47.23 m²',
        build: '47.23 m²',
        cover: '47.23 m²',
        rooms: '3',
        bedrooms: '2',
        bathroom: '1',
        garage: '',
        apartmentsPerFloor: '4',
        arranged: 'frente',
        orientation: 'norte',
        antiquity: '38 años',
      },
    ]
  },
  {
    title: 'Chacras',
    items: [
      {
        id: 3,
        code: 'CH001',
        name: 'Chacra Con Casa Y Camping A Estrenar En Zona Paradisíaca, Terminaciones De Excelente Calidad. Con Opción Alquiler!!!. Vive La Experiencia!!',
        address: 'A orillas del Rio azul, en El Bolsón',
        imageUrl: 'http://347inmobiliaria.com/img/3.jpg',
        description: 'Vivir en un lugar soñado, tranquilo y disfrutar de la naturaleza!!! *Chacra de 1 Hra. rodeada de Reserva Natural sobre la costa del río Azul. Tiene árboles nativos de cientos de años, árboles frutales. **CASA: Planos aprobados por la Municipalidad. Superficie cubierta 160 m² + superficie Semi cubierta 90 m². Construcción mixta material ladrillos de adobe y arena volcánica, revestida de sidding, doble vidrio termopanel, estufa Gymse de alto rendimiento. Comedor, Living, Patio, Cocina, Dependencia de servicio, Playroom, Lavadero, 1 baño, 1 habitación. Deck. Instalaciones para un segundo baño. Leñero y cochera. Muy luminosa. Posible Hostel. **CAMPING: con habilitación comercial y perfil de Google My business muy bien posicionado. Superficie cubierta 68,92 m2 + superficie Semi cubierta 11,89 m². Consta de 3 dormis canadienses de 12 m² c/u. area de acampe con Luz, agua, parrillas, mesas, asientos y fogones, 2 baños, 4 duchas, cocina comunitaria horno de barro, cocina industrial con horno, heladera y frizer. *Extras: Electricidad. Equipo de paneles solares de 3000 Kwa. pozo de agua potable. termo-tanque solar y a gas.',
        price: 'USD 380.000',
        size: '1 hectarea',
        build: '250 m²',
        cover: '160 m²',
        rooms: '3',
        bedrooms: '1',
        bathroom: '1',
        storage: '1',
        garage: '2',
        access: 'ripio',
        distanceToAsphalt: '1 km',
        orientation: 'norte',
        antiquity: '2 años',
      },
    ]
  },
  {
    title: 'Depósito',
    items: [
      {
        id: 4,
        code: 'DEP002',
        name: 'Gran deposito de uso industrial con dos oficinas independientes, amplio terreno, en Cerro Radal, Parque Industrial, Lago Puelo, Chubut',
        address: 'A 2 cuadras de la ruta 45 de Radal, a 6 km de Lago Puelo y 10 de El Bolsón',
        imageUrl: 'http://347inmobiliaria.com/img/4.jpg',
        description: '*Galpon/Deposito de 285 m². *casa/oficina de 117,50 m²con baño completo. *oficina/vestuario de 58 m² con baño completo. Buena ubicación zona industrial/comercial. Amplio terreno, Pozo de agua para riego. Instalación de electricidad trifásica. Todos los servicios',
        price: 'USD 385.000',
        size: '3180 m²',
        build: '285 m²',
        cover: '260 m²',
        rooms: '',
        bedrooms: '',
        bathroom: '1',
        storage: '',
        offices: '2',
        height: '6.5 m',
        garage: '',
        access: '',
        floorSupport: '20 t/m²',
        distanceToAsphalt: '',
        orientation: '',
        antiquity: '8 años',
      },
      {
        id: 9,
        code: 'DEP001',
        name: 'Excelente Y Amplio Depósito Zona Industrial Y Comercial En Esquina, 2.838,66 M2 De Terreno Sobre Ruta 45, Parque Industrial, Cerro Radal, Lago Puelo, Zona Comercial',
        address: '',
        imageUrl: 'http://347inmobiliaria.com/img/9.png',
        description: 'Gran depósito o nave industrial en esquina, inmejorable ubicación, en zona industrial de Lago Puelo, lugar de exponencial crecimiento turístico. *Terreno de 2.838,66 m2. *Maestranza o deposito de aproximadamente 450 m². *Dos oficinas tres baños. *Oficina 1, de 48,96 m², 2 ambientes, ubicada al lado de la maestranza, tiene baño completo, cocina, con entrada compartida y entrada independiente desde la calle. *Oficina 2, de 46 m², y un entre piso de 23, 40 m², ubicado en la parte de atrás del galpon, con cocina, baño completo, paredes recubiertas de madera, con estufa a gas y a leña, entrada independiente desde el jardín. *deposito aproximadamente 25 m². Instalación eléctrica trifásica fácil acceso para automóviles y camiones, en esquina sobre ruta de asfalto. pequeño centro comercial a 2 km., escuela a una cuadra. Ubicación del Galpon muy cercano al centro de Lago Puelo 5 km. y de El Bolson 8 km. Esta sobre ruta de acceso a Lago puelo desde la ruta 40, ruta de gran tránsito turístico, proveniente de las diversas localidades de El Hoyo, El Bolsón, El Maiten y Epuyen. En zona central de la Comarca Andina',
        price: 'USD 250.000',
        size: '550 m²',
        build: '550 m²',
        cover: '550 m²',
        rooms: '',
        bedrooms: '',
        bathroom: '3',
        storage: '',
        offices: '2',
        height: '7 m',
        garage: '6',
        access: '',
        floorSupport: ' t/m²',
        distanceToAsphalt: '',
        orientation: '',
        antiquity: '30 años',
      },
    ]
  },
];